import { helper } from '@ember/component/helper';

/**
 * Whether given params are 0 or truthy (except 'false')
 * @param {*[]} params
 * @return {boolean}
 */
export default helper(function isTruthyHelper(params) {
  return params.every(v => v === 0 || v && v !== 'false');
});
